angular.module('impactx.tender').controller('TenderTreatmentTypeListCtrl',
    ['selectedListItems',
    TenderTreatmentTypeListCtrl]);

function TenderTreatmentTypeListCtrl(selectedListItems) {
    var ctrl = this;

    this.getDetailLink = function() {
        return "tendertreatmenttype/" + selectedListItems.getFirstSelectedId();
    };

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: ctrl.getDetailLink,
            type:'link',
            condition: selectedListItems.isSingleSelection,
            process: "TenderTypeEdit"
        },
    ];

    this.meta = {
        rowTemplate: 'modules/tender/templates/tendertreatmenttypelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/tender/treatmenttype/list',
        id: "tendertreatmenttype",
        mainAction : {id:"new", link: "#/tendertreatmenttype/0", icon:"mdi-plus"},
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    };
}